// Client-side image URL wrapper that appends content-hash query params for cache-busting.
// Server routes and shared code should continue importing from shared/images directly.

import hashes from "virtual:image-hashes";
import { SubjectType, Orientation, CompanyName } from "kmmp";
import { FrameImage, BackgroundImage, ShadowBoxColor, SignatureJerseyPackageType, SignatureJerseyFrame, SampleFrameImage, SampleFrameName } from "kmmp/frontend";
import * as Version1 from "kmmp/orders/v1";
import * as Version2 from "kmmp/orders/v2";

// Re-export non-URL functions directly
export {
    getFrames,
    getSampleFrames,
    getSignaturePortraitBackgrounds,
    getBackgrounds,
    getPrestigePortraitFrameImages,
    countImages,
} from "shared/images";

function withHash(url: string): string {
    const hash = hashes[url];
    return hash ? `${url}?v=${hash}` : url;
}

import {
    getFrameUrl as _getFrameUrl,
    getBackgroundUrl as _getBackgroundUrl,
    findFancyFrame as _findFancyFrame,
    findSignaturePortraitFancyFrame as _findSignaturePortraitFancyFrame,
    getSampleFrameImageUrl as _getSampleFrameImageUrl,
    getShadowBoxImages as _getShadowBoxImages,
    getShadowBoxImage as _getShadowBoxImage,
    getSignatureJerseyImage as _getSignatureJerseyImage,
    getSampleFramePreviewImageUrl as _getSampleFramePreviewImageUrl,
} from "shared/images";

export function getFrameUrl(
    companyName: CompanyName,
    subjectType: SubjectType,
    frame: FrameImage,
    orientation: Orientation,
    size: Version1.Size | Version2.Size
): string {
    return withHash(_getFrameUrl(companyName, subjectType, frame, orientation, size));
}

export function getBackgroundUrl(
    companyName: CompanyName,
    subjectType: SubjectType,
    bg: BackgroundImage,
    orientation: Orientation,
    size: Version1.Size | Version2.Size
): string {
    return withHash(_getBackgroundUrl(companyName, subjectType, bg, orientation, size));
}

export function findFancyFrame(
    companyName: CompanyName,
    subjectType: SubjectType,
    frame: FrameImage | string,
    background: BackgroundImage,
    orientation: Orientation
): string {
    return withHash(_findFancyFrame(companyName, subjectType, frame, background, orientation));
}

export function findSignaturePortraitFancyFrame(
    frame: FrameImage,
    background: BackgroundImage,
    orientation: Orientation
): string {
    return withHash(_findSignaturePortraitFancyFrame(frame, background, orientation));
}

export function getSampleFrameImageUrl(company: CompanyName, sampleFrameImage: SampleFrameImage): string {
    return withHash(_getSampleFrameImageUrl(company, sampleFrameImage));
}

export function getShadowBoxImages(color: ShadowBoxColor): string[] {
    return _getShadowBoxImages(color).map(withHash);
}

export function getShadowBoxImage(color: ShadowBoxColor): string {
    return withHash(_getShadowBoxImage(color));
}

export function getSignatureJerseyImage(packageType: SignatureJerseyPackageType, frame: SignatureJerseyFrame): string {
    return withHash(_getSignatureJerseyImage(packageType, frame));
}

export function getSampleFramePreviewImageUrl(
    frameName: SampleFrameName,
    type: "packages" | "frames" | "corners",
    withWallBackground?: boolean
): string {
    return withHash(_getSampleFramePreviewImageUrl(frameName, type, withWallBackground));
}
